export const locale = {
  scroll_to_top: 'Scroll to top',
};
